// extracted by mini-css-extract-plugin
module.exports = {"icons":"ReportIcons_icons_TmHGB"};